module.exports = __webpack_public_path__ + "img/icon-invisible.0149bbb4.svg";